import { render, staticRenderFns } from "./SubmitMenu.vue?vue&type=template&id=301a50e5&scoped=true&"
import script from "./SubmitMenu.vue?vue&type=script&lang=js&"
export * from "./SubmitMenu.vue?vue&type=script&lang=js&"
import style0 from "./SubmitMenu.vue?vue&type=style&index=0&id=301a50e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301a50e5",
  null
  
)

export default component.exports